<template>
    <div class="ku-order-info">
        <van-overlay :show="show" />
        <van-loading style="z-index: 3" type="spinner" color="#1989fa" vertical>加载中...</van-loading>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Overlay, Loading, Popup } from 'vant';
    import {UrlSearch} from "@/utils/fu";
    import router from "@/router";

    Vue.use(Overlay).use(Loading).use(Popup);
    export default {
        name: "index",
        data() {
            return {
                show: true,
                order_no: true,
                ct: null
            }
        },
        mounted() {
            let href = new UrlSearch();
            this.order_no = href.sn;
            this.onLoad()
        },
        methods: {
            onLoad() {
                let _that = this;
                this.$API.orderPayStatus({sn: this.order_no}).then(res => {
                    return res.data;
                }).then(res => {
                    let data = res.data;
                    if (data.pay_status === 2) {
                        clearTimeout(_that.ct);
                        router.push('/success?no=' + data.no + '&order_no=' + data.order_no + '&food_type=' + data.pack)
                    } else {
                        _that.ct = setTimeout(function () {
                            _that.onLoad()
                        }, 3000);
                    }
                });
            }
        },
    }
</script>

<style lang="less" scoped>
.ku-order-info {
    .van-loading {
        position: absolute;
        left: 38%;
        top: 35%;
        width: 200px;
        height: 200px;
    }
}
</style>
